export class AccountsLoginModel {
    username?: string;
    password?: string;
  
    constructor(init?: Partial<AccountsLoginModel>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}